import React, { useState, useEffect } from 'react';
import leafImage from '../assets/leaf.png';
import carouselIcon from '../assets/carousel_icon.png';
import value1 from '../assets/values1.jpg';
import value2 from '../assets/values2.webp';
import value3 from '../assets/values3.jpg';
import value4 from '../assets/values4.webp';
import value5 from '../assets/values5.jpg';
import value6 from '../assets/values6.webp';
// Custom styles for Ethics component
const styles = `
.ethics-section {
    background-color: #FFFDF7;
    position: relative;
    overflow: hidden;
    padding: 60px 0 0 0;
}

/* Main Heading */
.ethics-main-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 2.8rem;
    font-weight: 800;
    color: #5A3411;
    text-align: center;
    margin-bottom: 50px;
}

/* Cards Section */

.ethics-cards-container {
    position: relative;
    z-index: 1;
}

/* Individual Card */
.ethics-card {
    background-color: rgba(90, 52, 17, 0.06);
    border-radius: 20px;
    padding: 35px 30px;
    height: 100%;
    position: relative;
    overflow: hidden;
}

/* Leaf background in card - positioned on right side */
.ethics-card::before {
    content: '';
    position: absolute;
    top: 0;
    right: -20%;
    width: 80%;
    height: 100%;
    background-image: url(${leafImage});
    background-size: contain;
    background-position: right center;
    background-repeat: no-repeat;
    opacity: 0.10;
    pointer-events: none;
    z-index: 0;
}

/* Decorative circles in bottom-left of cards - half visible */
.ethics-card-circle-1 {
    position: absolute;
    bottom: -40px;
    left: 20px;
    width: 80px;
    height: 80px;
    border: 2px solid #5A3411;
    border-radius: 50%;
    background: transparent;
    opacity: 0.3;
    z-index: 0;
}

.ethics-card-circle-2 {
    position: absolute;
    bottom: -25px;
    left: 80px;
    width: 50px;
    height: 50px;
    border: 2px solid #5A3411;
    border-radius: 50%;
    background: transparent;
    opacity: 0.25;
    z-index: 0;
}

.ethics-card-content {
    position: relative;
    z-index: 1;
}

.ethics-card-heading {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.8rem;
    font-weight: 800;
    color: #5A3411;
    margin-bottom: 15px;
}

.ethics-card-text {
    font-family: 'Quicksand', sans-serif;
    font-size: 1rem;
    color: rgba(90, 52, 17, 0.85);
    line-height: 1.7;
    margin-bottom: 0;
}

/* Values/Carousel Section */
.ethics-values-section {
    position: relative;
    padding: 60px 0 0 0;
    z-index: 1;
}

.ethics-values-heading {
    position: absolute;
    top: 30px;
    left: 50px;
    font-family: 'Quicksand', sans-serif;
    font-size: 2rem;
    font-weight: 800;
    color: white;
    z-index: 10;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    -webkit-text-stroke: 1px #ffffff;
    text-stroke: 1px #ffffff;
    paint-order: stroke fill;
}

.ethics-carousel-wrapper {
    position: relative;
    width: 100%;
    height: 500px;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.ethics-carousel-slide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    opacity: 0;
    transition: opacity 0.8s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.ethics-carousel-slide.active {
    opacity: 1;
    z-index: 1;
}

.ethics-slide-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: black;
    opacity: 0.54;
    z-index: 1;
}

.ethics-slide-content {
    position: relative;
    z-index: 2;
    color: white;
    max-width: 800px;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.ethics-slide-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 1.5rem;
    object-fit: contain;
}

.ethics-slide-content h3 {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.8rem;
    font-weight: 800;
    margin-bottom: 0.8rem;
    line-height: 1.2;
    -webkit-text-stroke: 1px #ffffff;
    text-stroke: 1px #ffffff;
    paint-order: stroke fill;
}

.ethics-slide-content p {
    font-family: 'Quicksand', sans-serif;
    font-size: 1.1rem;
    line-height: 1.6;
    max-width: 700px;
    opacity: 0.95;
}

.ethics-carousel-pagination {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 3;
}

.ethics-pagination-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    background-color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0;
}

.ethics-pagination-dot.active {
    background-color: #FF800D;
    transform: scale(1.3);
}

/* Bottom Ellipse Container */
.ethics-ellipse-container {
    margin-top: 40px;
    padding-bottom: 0;
}

/* Bottom Ellipse */
.ethics-bottom-ellipse {
    width: 100%;
    height: 30px;
    background-color: #2F4B20;
    border-radius: 50% 50% 0 0 / 100% 100% 0 0;
    position: relative;
    z-index: 2;
}

/* Responsive Styles */
@media (max-width: 1199.98px) {
    .ethics-main-heading {
        font-size: 2.5rem;
        margin-bottom: 45px;
    }
    
    .ethics-card-heading {
        font-size: 1.6rem;
    }
    
    .ethics-card-text {
        font-size: 0.95rem;
    }
    
    .ethics-carousel-wrapper {
        height: 450px;
    }
}

@media (max-width: 991.98px) {
    .ethics-section {
        padding: 50px 0 0 0;
    }
    
    .ethics-main-heading {
        font-size: 2.2rem;
        margin-bottom: 40px;
    }
    
    .ethics-card {
        padding: 30px 25px;
        margin-bottom: 20px;
    }
    
    .ethics-card-heading {
        font-size: 1.5rem;
    }
    
    .ethics-card-text {
        font-size: 0.9rem;
    }
    
    .ethics-values-heading {
        font-size: 1.7rem;
        left: 30px;
        top: 25px;
    }
    
    .ethics-carousel-wrapper {
        height: 420px;
        border-radius: 20px;
    }
    
    .ethics-slide-content h3 {
        font-size: 1.6rem;
    }
    
    .ethics-slide-content p {
        font-size: 1rem;
    }
    
    .ethics-card-circle-1 {
        width: 70px;
        height: 70px;
        bottom: -35px;
        left: 15px;
    }
    
    .ethics-card-circle-2 {
        width: 45px;
        height: 45px;
        bottom: -22px;
        left: 65px;
    }
}

@media (max-width: 767.98px) {
    .ethics-section {
        padding: 40px 0 0 0;
    }
    
    .ethics-main-heading {
        font-size: 1.8rem;
        margin-bottom: 30px;
        padding: 0 15px;
    }
    
    .ethics-card {
        padding: 25px 20px;
        margin-bottom: 15px;
        border-radius: 16px;
    }
    
    .ethics-card-heading {
        font-size: 1.4rem;
        margin-bottom: 12px;
    }
    
    .ethics-card-text {
        font-size: 0.875rem;
        line-height: 1.6;
    }
    
    .ethics-values-section {
        padding: 40px 0 0 0;
    }
    
    .ethics-values-heading {
        font-size: 1.5rem;
        left: 20px;
        top: 20px;
    }
    
    .ethics-carousel-wrapper {
        height: 380px;
        border-radius: 16px;
    }
    
    .ethics-slide-icon {
        width: 60px;
        height: 60px;
        margin-bottom: 1rem;
    }
    
    .ethics-slide-content {
        padding: 1.5rem;
    }
    
    .ethics-slide-content h3 {
        font-size: 1.4rem;
    }
    
    .ethics-slide-content p {
        font-size: 0.9rem;
    }
    
    .ethics-bottom-ellipse {
        height: 28px;
    }
    
    .ethics-card-circle-1 {
        width: 60px;
        height: 60px;
        bottom: -30px;
        left: 12px;
    }
    
    .ethics-card-circle-2 {
        width: 40px;
        height: 40px;
        bottom: -20px;
        left: 55px;
    }
    
    .ethics-ellipse-container {
        margin-top: 30px;
    }
}

@media (max-width: 575.98px) {
    .ethics-section {
        padding: 30px 0 0 0;
    }
    
    .ethics-main-heading {
        font-size: 1.5rem;
        margin-bottom: 25px;
    }
    
    .ethics-card {
        padding: 20px 18px;
        margin-bottom: 12px;
        border-radius: 14px;
    }
    
    .ethics-card-heading {
        font-size: 1.25rem;
        margin-bottom: 10px;
    }
    
    .ethics-card-text {
        font-size: 0.8rem;
        line-height: 1.55;
    }
    
    .ethics-values-section {
        padding: 30px 0 0 0;
    }
    
    .ethics-values-heading {
        font-size: 1.3rem;
        left: 15px;
        top: 15px;
    }
    
    .ethics-carousel-wrapper {
        height: 350px;
        border-radius: 14px;
    }
    
    .ethics-slide-icon {
        width: 50px;
        height: 50px;
        margin-bottom: 0.8rem;
    }
    
    .ethics-slide-content {
        padding: 1rem;
    }
    
    .ethics-slide-content h3 {
        font-size: 1.2rem;
        margin-bottom: 0.5rem;
    }
    
    .ethics-slide-content p {
        font-size: 0.85rem;
        line-height: 1.5;
    }
    
    .ethics-carousel-pagination {
        bottom: 20px;
        gap: 8px;
    }
    
    .ethics-pagination-dot {
        width: 8px;
        height: 8px;
    }
    
    .ethics-bottom-ellipse {
        height: 24px;
    }
    
    .ethics-card-circle-1 {
        width: 50px;
        height: 50px;
        bottom: -25px;
        left: 10px;
    }
    
    .ethics-card-circle-2 {
        width: 35px;
        height: 35px;
        bottom: -17px;
        left: 45px;
    }
    
    .ethics-ellipse-container {
        margin-top: 25px;
    }
}

@media (max-width: 400px) {
    .ethics-main-heading {
        font-size: 1.3rem;
        margin-bottom: 20px;
    }
    
    .ethics-card {
        padding: 18px 15px;
        border-radius: 12px;
    }
    
    .ethics-card-heading {
        font-size: 1.1rem;
    }
    
    .ethics-card-text {
        font-size: 0.75rem;
    }
    
    .ethics-values-heading {
        font-size: 1.1rem;
        left: 12px;
        top: 12px;
    }
    
    .ethics-carousel-wrapper {
        height: 320px;
    }
    
    .ethics-slide-icon {
        width: 40px;
        height: 40px;
    }
    
    .ethics-slide-content h3 {
        font-size: 1.1rem;
    }
    
    .ethics-slide-content p {
        font-size: 0.8rem;
    }
    
    .ethics-bottom-ellipse {
        height: 20px;
    }
    
    .ethics-card-circle-1 {
        width: 45px;
        height: 45px;
        bottom: -22px;
        left: 8px;
    }
    
    .ethics-card-circle-2 {
        width: 30px;
        height: 30px;
        bottom: -15px;
        left: 40px;
    }
    
    .ethics-ellipse-container {
        margin-top: 20px;
    }
}
`;

const Ethics = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const slides = [
        {
            image: value1,
            title: "Comfort & Wellbeing (Hygge)",
            description: "Creating warm, cosy spaces where children feel safe and inspired."
        },
        {
            image: value2,
            title: "Curiosity",
            description: "Encouraging children’s natural wonder and love of discovery."
        },
        {
            image: value3,
            title: "Independence",
            description: "Empowering children to make choices and grow in confidence."
        },
        {
            image: value4,
            title: "Creativity",
            description: "Inspiring imagination through open-ended play and natural environments."
        },
        {
            image: value5,
            title: "Connection",
            description: "Building strong, trusting relationships with families and the community."
        },
        {
            image: value6,
            title: "Sustainability",
            description: "Teaching care for the planet through mindful, eco-conscious practices."
        }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((current) => (current + 1) % slides.length);
        }, 5000);
        return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <>
            <style>{styles}</style>
            <section className="ethics-section">

                <div className="container">
                    {/* Main Heading */}
                    <h2 className="ethics-main-heading">Our Ethos, Mission & Values</h2>

                    {/* Cards Row */}
                    <div className="row ethics-cards-container">
                        {/* Ethics Card */}
                        <div className="col-12 col-md-6 mb-4 mb-md-0">
                            <div className="ethics-card">
                                {/* Decorative Circles */}
                                <div className="ethics-card-circle-1"></div>
                                <div className="ethics-card-circle-2"></div>
                                <div className="ethics-card-content">
                                    <h3 className="ethics-card-heading">Ethos</h3>
                                    <p className="ethics-card-text">
                                        At Zubis Nursery, children learn through curious exploration in spaces that feel like home — calm, natural, and full of wonder. Our educators are guides and co-learners, supporting each child's unique rhythm and love of discovery.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Mission Card */}
                        <div className="col-12 col-md-6">
                            <div className="ethics-card">
                                {/* Decorative Circles */}
                                <div className="ethics-card-circle-1"></div>
                                <div className="ethics-card-circle-2"></div>
                                <div className="ethics-card-content">
                                    <h3 className="ethics-card-heading">Mission</h3>
                                    <p className="ethics-card-text">
                                        To nurture curious, confident, and content learners in Hygge-inspired environments, fostering independence, creativity, and meaningful connections with families and the world around them.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Values Carousel Section */}
                    <div className="ethics-values-section">
                        <div className="ethics-carousel-wrapper">
                            {/* Our Values Heading (positioned on carousel) */}
                            <h3 className="ethics-values-heading">Our Values</h3>

                            {slides.map((slide, index) => (
                                <div
                                    key={index}
                                    className={`ethics-carousel-slide ${index === activeIndex ? 'active' : ''}`}
                                    style={{ backgroundImage: `url(${slide.image})` }}
                                >
                                    <div className="ethics-slide-overlay"></div>
                                    <div className="ethics-slide-content">
                                        <img src={carouselIcon} alt="icon" className="ethics-slide-icon" />
                                        <h3>{slide.title}</h3>
                                        <p>{slide.description}</p>
                                    </div>
                                </div>
                            ))}

                            <div className="ethics-carousel-pagination">
                                {slides.map((_, index) => (
                                    <button
                                        key={index}
                                        className={`ethics-pagination-dot ${index === activeIndex ? 'active' : ''}`}
                                        onClick={() => setActiveIndex(index)}
                                        aria-label={`Go to slide ${index + 1}`}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Bottom Ellipse */}
                <div className="ethics-ellipse-container container">
                    <div className="ethics-bottom-ellipse"></div>
                </div>
            </section>
        </>
    );
};

export default Ethics;
